import { PageHeader } from '@fukuri-admins/ui/common';

type Props = {
  /** 利用者氏名 */
  fullName: string;
};

/**
 * 利用者詳細ヘッダー Presentation
 *
 * - パンくずリスト：利用者一覧 > {fullName}
 */
export const UserDetailHeaderPresentation: React.FC<Props> = ({ fullName }) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[{ label: '利用者一覧', href: '/users' }, { label: fullName }]}
  />
);
